import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Quote, BadgeCheck } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const photoSrc = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`);

export const SuccessStories = () => {
  const { t } = useTranslation();
  const [stories, setStories] = useState([]);
  useEffect(() => {
    api.get("/public/stories").then(({ data }) => setStories(data)).catch(() => {});
  }, []);
  if (!stories.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 pb-16" data-testid="success-stories">
      <span className="text-xs font-bold uppercase tracking-wider text-emerald-700">{t("stories.eyebrow")}</span>
      <h2 className="mt-2 font-heading text-3xl font-extrabold sm:text-4xl">{t("stories.title")}</h2>
      <div className="mt-8 grid gap-5 md:grid-cols-3">
        {stories.map((s, i) => (
          <motion.figure key={s.story_id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
            className="relative flex flex-col rounded-3xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="story-card">
            {s.sample && <span className="absolute right-4 top-4 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-500" data-testid="story-sample-tag">{t("stories.sample")}</span>}
            <Quote className="h-7 w-7 text-orange-400" />
            <blockquote className="mt-3 flex-1 text-base leading-relaxed text-slate-700">“{s.quote}”</blockquote>
            <figcaption className="mt-6 flex items-center gap-3">
              {s.photo_url
                ? <img src={photoSrc(s.photo_url)} alt={s.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-orange-200" />
                : <span className="flex h-14 w-14 items-center justify-center rounded-full bg-orange-100 font-heading text-xl font-bold text-orange-700">{s.name[0]}</span>}
              <div>
                <p className="font-heading font-bold text-slate-900">{s.name}</p>
                <p className="flex items-center gap-1 text-sm font-semibold text-emerald-700"><BadgeCheck className="h-4 w-4" /> {s.role} · {s.company}</p>
                {s.course && <p className="text-xs text-slate-500">{s.course}</p>}
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
